import { observer } from "mobx-react-lite";
import { Box } from "@chakra-ui/react";

import getScrollBarProps from "@/styles/scrollBarProps";
import SubPanel, { ISubPanel } from ".";

function SubPanelWithScrollBar({ children, ...others }: ISubPanel) {
  return (
    <SubPanel
      flexShrink={0}
      overflow="hidden"
      display="flex"
      flexDir="column"
      alignItems="stretch"
      {...others}
    >
      <Box
        className="c-subpanel-with-scroll-bar-inner"
        // w="100%"
        flex={1}
        display="flex"
        flexDir="column"
        alignItems="stretch"
        {...getScrollBarProps()}
      >
        {children}
      </Box>
    </SubPanel>
  );
}

export default observer(SubPanelWithScrollBar);
